import { DurationTypeModule } from "@/store/modules/duration-module";

export function getDurationTypeDisplay(id: number) {
  const durationType = DurationTypeModule.durationTypes.find((eachType) => eachType.id === id);
  return durationType ? durationType.name : "-";
}
